<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <!-- ngb nav -->
    <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs">
      <li [ngbNavItem]="1">
        <a ngbNavLink [routerLink]="['/quiz/leaderboard']">Leaderboard</a>
      </li>

      <li [ngbNavItem]="2">
        <a ngbNavLink routerLink="/statistics/student-statistics">Statistics</a>
      </li>
    </ul>
    <div [ngbNavOutlet]="nav" class="mt-2"></div>
    <!-- end -->

    <div class="row">
      <div class="col-12">
        <!-- message card -->
        <ng-container *ngIf="ngbAlertMessage; else loader">
          <div class="card alert-card background-image" [ngClass]="{
              info: alertType == 'info',
              'close-to-bottom': alertType == 'closeToBottom',
              'relegation-warning': alertType == 'danger'
            }">
            <div class="card-body d-flex align-items-center justify-content-between p-1">
              <div>
                <h2 class="text-white">{{ ngbAlertHeading }}</h2>
                <p class="text-white">{{ ngbAlertMessage }}</p>
              </div>
              <img src="../../../../../assets/img/Group 5532.png" alt="" />
            </div>
          </div>
        </ng-container>

        <ng-template #loader>
          <div class="card">
            <div class="card-body">
              <app-loader [height]="139" [mb]="0"></app-loader>
            </div>
          </div>
        </ng-template>
        <!-- message card -->

        <!-- start new leaderboard -->
        <div class="row">
          <div class="col-md-8 col-12">
            <ng-container *ngIf="
                rankingLeagueData && rankingLeagueData.length > 0;
                else isLoadingData
              ">
              <div class="card leaderboard-top-section background-image">
                <div class="card-body d-flex flex-column p-0">
                  <div class="d-flex justify-content-between align-items-start pt-2 pr-2">
                    <div></div>
                    <div class="form-group">
                      <select id="basicSelect" class="form-control font-weight-bolder"
                        (change)="leaderboardSelectChange($event)">
                        <option value="week">This Week</option>
                        <option value="today">Today</option>
                      </select>
                    </div>
                  </div>

                  <div class="d-flex justify-content-center align-items-end image-container">
                    <div class="d-flex flex-column">
                      <div class="d-flex flex-column align-items-center position-container">
                        <div class="image-wrapper">
                          <img class="first-image" src="../../../../../assets/img/avator1.png" height="80" width="80"
                            alt="" />
                          <img class="overlay-image" src="../../../../../assets/img/Group 48.png" height="25" width="25"
                            alt="" />
                        </div>
                        <p>{{ rankingLeagueData[1]?.firstName }}</p>
                        <p>
                          {{
                          leaderboardPeriod == "week"
                          ? rankingLeagueData[1]?.weekPoints
                          : rankingLeagueData[1]?.pointsToday
                          }}p
                        </p>
                      </div>
                      <img src="../../../../../assets/img/Group 1000001763.png" height="150" width="110" alt="" />
                    </div>

                    <div class="d-flex flex-column">
                      <div class="d-flex flex-column align-items-center position-container">
                        <div class="image-wrapper">
                          <img class="first-image" src="../../../../../assets/img/avator1.png" height="80" width="80"
                            alt="" />
                          <img class="overlay-image" src="../../../../../assets/img/Group 45.png" height="25" width="25"
                            alt="" />
                        </div>
                        <p>{{ rankingLeagueData[0]?.firstName }}</p>
                        <p>
                          {{
                          leaderboardPeriod == "week"
                          ? rankingLeagueData[0]?.weekPoints
                          : rankingLeagueData[0]?.pointsToday
                          }}p
                        </p>
                      </div>
                      <img src="../../../../../assets/img/Group 1000001761 (1).png" height="200" width="140" alt="" />
                    </div>
                    <div class="d-flex flex-column">
                      <div class="d-flex flex-column align-items-center position-container">
                        <div class="image-wrapper">
                          <img class="first-image" src="../../../../../assets/img/avator1.png" height="80" width="80"
                            alt="" />
                          <img class="overlay-image" src="../../../../../assets/img/Group 49.png" height="25" width="25"
                            alt="" />
                        </div>
                        <p>{{ rankingLeagueData[2]?.firstName }}</p>
                        <p>
                          {{
                          leaderboardPeriod == "week"
                          ? rankingLeagueData[2]?.weekPoints
                          : rankingLeagueData[2]?.pointsToday
                          }}p
                        </p>
                      </div>
                      <img src="../../../../../assets/img/Group 1000001762.png" height="120" width="140" alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
            <ng-template #isLoadingData>
              <div class="card">
                <div class="card-body">
                  <app-loader [height]="400" [mb]="0"></app-loader>
                </div>
              </div>
            </ng-template>
          </div>
          <div class="col-md-4 col-12">
            <div class="card achievements-card">
              <div class="card-body">
                <h4 class="font-weight-bolder mb-1">My Achievements</h4>
                <div class="mb-2">
                  <p class="mb-0">Your Position</p>
                  <div class="media mb-1 mb-md-0">
                    <div class="avatar bg-light-primary mr-1">
                      <div class="avatar-content">
                        <img src="../../../../../assets/img/Group 1.png" height="32" alt="" />
                      </div>
                    </div>
                    <div class="media-body my-auto">
                      <div *ngIf="!userLeagueDetails">
                        <div class="text-placeholder"></div>
                      </div>
                      <div *ngIf="userLeagueDetails">
                        <h6 class="font-weight-bolder mb-0">
                          {{ userLeagueDetails?.position }}
                        </h6>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="mb-2">
                  <p class="mb-0">Level Title</p>
                  <div class="media mb-1 mb-md-0">
                    <div class="avatar bg-light-primary mr-1">
                      <div class="avatar-content">
                        <img src="../../../../../assets/img/Group 1 (1).png" height="32" alt="" />
                      </div>
                    </div>
                    <div class="media-body my-auto">
                      <div *ngIf="!userLeagueDetails">
                        <div class="text-placeholder"></div>
                      </div>
                      <div *ngIf="userLeagueDetails">
                        <h6 class="font-weight-bolder mb-0">
                          {{ userLeagueDetails?.leagueLevelTitle }}
                        </h6>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="mb-2">
                  <p class="mb-0">Regional Level</p>
                  <div class="media mb-1 mb-md-0">
                    <div class="avatar bg-light-primary mr-1">
                      <div class="avatar-content">
                        <img src="../../../../../assets/img/Group 1 (2).png" height="32" alt="" />
                      </div>
                    </div>
                    <div class="media-body my-auto">
                      <div *ngIf="!userLeagueDetails">
                        <div class="text-placeholder"></div>
                      </div>
                      <div *ngIf="userLeagueDetails">
                        <h6 class="font-weight-bolder mb-0">
                          {{ userLeagueDetails?.type }}
                        </h6>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="mb-2">
                  <p class="mb-0">
                    {{
                    leaderboardPeriod == "week" ? "Weekly" : "Daily"
                    }}
                    Points
                  </p>
                  <div class="media mb-1 mb-md-0">
                    <div class="avatar bg-light-primary mr-1">
                      <div class="avatar-content">
                        <img src="../../../../../assets/img/Group 2.png" height="32" alt="" />
                      </div>
                    </div>
                    <div class="media-body my-auto">
                      <div *ngIf="!userLeagueDetails">
                        <div class="text-placeholder"></div>
                      </div>
                      <div *ngIf="userLeagueDetails">
                        <h6 class="font-weight-bolder mb-0">
                          {{
                          leaderboardPeriod == "week"
                          ? userLeagueDetails?.weekPoints
                          : userLeagueDetails?.pointsToday
                          }}
                        </h6>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <p class="mb-0">Total Points</p>
                  <div class="media mb-1 mb-md-0">
                    <div class="avatar bg-light-primary mr-1">
                      <div class="avatar-content">
                        <img src="../../../../../assets/img/Group 2 (1).png" height="32" alt="" />
                      </div>
                    </div>
                    <div class="media-body my-auto">
                      <div *ngIf="!userLeagueDetails">
                        <div class="text-placeholder"></div>
                      </div>
                      <div *ngIf="userLeagueDetails">
                        <h6 class="font-weight-bolder mb-0">
                          {{ userLeagueDetails?.totalPoints }}
                        </h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- end new leaderboard -->
        <div class="card">
          <div class="card-body">
            <ng-container *ngIf="!isLoading; else isLoadingDT">
              <div class="d-flex flex-wrap flex-row align-items-center justify-content-between mb-1 leaderboard-header">
                <h4 class="mb-0 mt-0">Points LeaderBoard</h4>
                <div class="d-flex align-items-center">
                  <div class="d-flex align-items-center">
                    <div class="promotion"></div>
                    <p class="mb-0">Promotion Zone</p>
                  </div>
                  <div class="d-flex align-items-center ml-1">
                    <div class="relegation"></div>
                    <p class="mb-0">Relegation Zone</p>
                  </div>
                </div>
                <div class="pointer text-muted" (click)="showMoreInfo()" placement="left"
                  ngbTooltip="Leaderboard breakdown">
                  More info
                  <i data-feather="info" class="font-medium-5"></i>
                </div>
              </div>
              <!-- <hr /> -->
              <ngx-datatable *ngIf="rankingLeagueData && rankingLeagueData?.length > 0" class="bootstrap core-bootstrap"
                [columnMode]="ColumnMode.force" [headerHeight]="40" [footerHeight]="50" [rowHeight]="58" [limit]="10"
                [rows]="rankingLeagueData" [scrollbarH]="true" [externalPaging]="true"
                [count]="totalCount" [offset]="currentOffset" [rowClass]="getRowClass"
                (page)="fetchRequests($event)">
                <ngx-datatable-column name="Name" prop="firstName" [width]="280" [sortable]="true" [flexGrow]="1">
                  <ng-template let-row="row" let-rowIndex="rowIndex" let-name="value" ngx-datatable-cell-template>
                    <div class="d-flex align-items-center">
                      <!-- <div class="avatar mr-1 ml-0 bg-light-primary">
                        <div class="avatar-content">
                          {{ (currentPage - 1) * pageSize + rowIndex + 1 }}
                        </div>
                      </div> -->
                      <span class="mr-1 text-dark">{{
                        (currentPage - 1) * pageSize + rowIndex + 1
                        }}</span>
                      <img src="../../../../../assets/img/avator1.png" height="35" width="35" alt="avator" />
                      <div class="cell-line-height">
                        <p class="font-small-3 line-height-1 mb-0">
                          {{ name }}
                        </p>
                        <small class="mb-0 text-muted font-small-1">{{
                          row.schoolName?.includes('Demo') ? '-' : row.schoolName
                          }}</small>
                      </div>
                    </div>
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column name="Type" prop="type" [width]="120" [sortable]="true" [flexGrow]="1">
                </ngx-datatable-column>
                <ngx-datatable-column name="Level" prop="leagueLevelTitle" [width]="80" [sortable]="true"
                  [flexGrow]="1">
                </ngx-datatable-column>
                <ngx-datatable-column name="{{
                    leaderboardPeriod == 'week'
                      ? 'Weekly Points'
                      : 'Daily Points'
                  }}" prop="{{
                    leaderboardPeriod == 'week' ? 'weekPoints' : 'pointsToday'
                  }}" [width]="100" [sortable]="true" [flexGrow]="1"></ngx-datatable-column>
                <ngx-datatable-column name="Total Points" prop="totalPoints" [width]="100" [sortable]="true"
                  [flexGrow]="1"></ngx-datatable-column>
              </ngx-datatable>
              <div *ngIf="rankingLeagueData && rankingLeagueData?.length === 0">
                <ngb-alert [dismissible]="false" class="mb-0" [type]="'primary'">
                  <div class="alert-body text-center">
                    <span [data-feather]="'alert-circle'" [class]="'mr-25 align-middle'" [size]="35"></span>
                    <span> No leaderboard members</span>
                  </div>
                </ngb-alert>
              </div>
            </ng-container>
            <ng-template #isLoadingDT>
              <app-loader [height]="300" [mb]="0"></app-loader>
            </ng-template>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>